export const formatDescription = (medicationDescription: string) => {
  if (medicationDescription) {
    medicationDescription = medicationDescription.replace(/\\par[d]?/g, '')
    const rtf = medicationDescription.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()

    return rtf
  } else return ''
}
